export const GET_JOB_REQUEST = "GET_JOB_REQUEST";
export const GET_JOB_SUCCESS = "GET_JOB_SUCCESS";
export const GET_JOB_FAILURE = "GET_JOB_FAILURE";


export const GET_SERVICES_DATA = "GET_SERVICES_DATA";
export const GET_JOBS_DATA = "GET_JOBS_DATA";